// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftSquareOutlinedSvg from "@fishx/icons-svg/es/asn/LeftSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var LeftSquareOutlined = function LeftSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftSquareOutlinedSvg
  }));
};

LeftSquareOutlined.displayName = 'LeftSquareOutlined';
export default React.forwardRef(LeftSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LeftSquareOutlined.js
// module id = 3025
// module chunks = 0